<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.exportacao"
        ref="RkmDataTable"
    >
        <template v-slot:cell(actions)="row">
            <rkm-button
                @click="handleDownload(row.item)"
                color="primary"
                small
                title="Download"
            >
                <rkm-icon icon="download" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { error, repository } from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                { key: 'usuarioNome', label: 'Usuário', name: 'cadastroCidadao.nome', searchable: true, sortable: true },
                { key: 'dataHoraExportacao', label: 'Data/Hora de exportação', name: 'imunizacaoExportacao.dataHoraExportacao' },
                { key: 'mes', label: 'Mês', name: 'imunizacaoExportacao.mes', searchable: true, sortable: true },
                { key: 'ano', label: 'Ano', name: 'imunizacaoExportacao.ano', searchable: true, sortable: true },
                { class: 'col-min text-center', key: 'actions', label: 'Ações' },
            ]
        },
    },
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('imunizacao.exportacao')
        }
    },
    methods: {
        handleDownload(item) {
            this.repositories.exportacao.download(item.id)
                .then(response => {
                    const file = response.headers['content-disposition'].split('filename=')[1]
                    const blob = new Blob([response.data])
                    const link = document.createElement('a')

                    link.href = URL.createObjectURL(blob)
                    link.download = file
                    link.click()
                })
                .catch(this.handleError)
        },
        refresh() {
            this.$refs.RkmDataTable.refresh()
        },
    },
    mixins: [ error, repository ],
}
</script>